import styled from "styled-components";
import fonts from "styles/fonts";

export const StyledErrorMessage = styled.p`
  font-family: var(--font-family-base);
  font-size: ${fonts.small};
`;
